import { render } from "./PostpartumModal.vue?vue&type=template&id=1ab36134&scoped=true"
import script from "./PostpartumModal.vue?vue&type=script&lang=js"
export * from "./PostpartumModal.vue?vue&type=script&lang=js"

import "./PostpartumModal.vue?vue&type=style&index=0&id=1ab36134&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab36134"]])

export default __exports__